export type ARRBand = '<10K_ARR' | '10K-100K' | '100K-1M' | '1M+'

export interface BenchmarkRecord {
  median_attribution_gap_price: number
  median_attribution_gap_features: number
  median_attribution_gap_support: number
  median_activation_failure_share: number
  median_engagement_decay_share: number
  median_true_price_sensitivity_share: number
  median_survey_noise_pp: number
}

export const SAAS_BENCHMARKS: {
  overall: BenchmarkRecord
  by_arr_band: Record<ARRBand, BenchmarkRecord>
} = {
  overall: {
    median_attribution_gap_price: 0.18,
    median_attribution_gap_features: -0.04,
    median_attribution_gap_support: 0.07,
    median_activation_failure_share: 0.22,
    median_engagement_decay_share: 0.17,
    median_true_price_sensitivity_share: 0.12,
    median_survey_noise_pp: 14,
  },
  by_arr_band: {
    '<10K_ARR': {
      median_attribution_gap_price: 0.31,
      median_attribution_gap_features: -0.06,
      median_attribution_gap_support: 0.09,
      median_activation_failure_share: 0.28,
      median_engagement_decay_share: 0.20,
      median_true_price_sensitivity_share: 0.18,
      median_survey_noise_pp: 18,
    },
    '10K-100K': {
      median_attribution_gap_price: 0.22,
      median_attribution_gap_features: -0.04,
      median_attribution_gap_support: 0.08,
      median_activation_failure_share: 0.24,
      median_engagement_decay_share: 0.18,
      median_true_price_sensitivity_share: 0.14,
      median_survey_noise_pp: 15,
    },
    '100K-1M': {
      median_attribution_gap_price: 0.15,
      median_attribution_gap_features: -0.03,
      median_attribution_gap_support: 0.06,
      median_activation_failure_share: 0.19,
      median_engagement_decay_share: 0.15,
      median_true_price_sensitivity_share: 0.10,
      median_survey_noise_pp: 12,
    },
    '1M+': {
      median_attribution_gap_price: 0.09,
      median_attribution_gap_features: -0.02,
      median_attribution_gap_support: 0.04,
      median_activation_failure_share: 0.14,
      median_engagement_decay_share: 0.11,
      median_true_price_sensitivity_share: 0.07,
      median_survey_noise_pp: 9,
    },
  },
}

export function getBenchmarks(arrBand?: ARRBand): BenchmarkRecord {
  if (arrBand && arrBand in SAAS_BENCHMARKS.by_arr_band) {
    return SAAS_BENCHMARKS.by_arr_band[arrBand]
  }
  return SAAS_BENCHMARKS.overall
}

export function formatBenchmarkComparison(
  actualGap: number,
  reason: string,
  arrBand?: ARRBand,
): string {
  const bench = getBenchmarks(arrBand)
  const benchGap = reason === 'price' ? bench.median_attribution_gap_price
    : reason === 'features' ? bench.median_attribution_gap_features
    : reason === 'support' ? bench.median_attribution_gap_support
    : bench.median_attribution_gap_price

  const diff = actualGap - benchGap
  const absDiff = Math.abs(diff)
  const direction = diff > 0 ? 'larger' : 'smaller'
  const benchPp = Math.round(benchGap * 100)
  const actualPp = Math.round(actualGap * 100)

  return `Your ${reason}-attribution gap (${actualPp > 0 ? '+' : ''}${actualPp}pp) is ${Math.round(absDiff * 100)}pp ${direction} than the SaaS median (${benchPp > 0 ? '+' : ''}${benchPp}pp)${absDiff > 0.05 ? ' — your survey is noisier than typical' : ''}.`
}
